module.exports = __webpack_public_path__ + "static/media/corrigir.840a264d.svg";